import { HeroIcon } from '@components/HeroIcon'
import { Animated } from 'react-native'
import { useOpacityAnimation } from '@hooks/useOpacityAnimation'
import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { XStack, Text, useMedia } from 'tamagui'

export function DefaultSectionTitle({
  onButtonPress,
  showButton = true,
  isHoveringSection,
  title,
  accessory,
}: {
  title: string
  onButtonPress: () => void
  showButton: boolean
  isHoveringSection: boolean
  /** Conteúdo alinhado à direita, na mesma linha do título. */
  accessory?: ReactNode
}) {
  const [buttonIsHovered, setButtonIsHovered] = useState(false)
  const { t } = useTranslation('Home')
  const media = useMedia()
  const { startAnimation, interpolatedOpacity } = useOpacityAnimation()
  const iconSize = media.gtSm ? 16 : 14
  const setColor = buttonIsHovered ? '$accent-pressed' : '$accent'
  const setOpacity = media.gtMd ? interpolatedOpacity : 1
  const setDisplay = () => {
    if (media.gtMd) return isHoveringSection ? 'flex' : 'none'
    return 'flex'
  }

  const handlePress = () => {
    onButtonPress()
  }

  useEffect(() => {
    startAnimation(isHoveringSection)
  }, [isHoveringSection, startAnimation])

  return (
    <XStack marginBottom="$size.spacing-xs" flex={1}>
      <Text
        color="$text-primary"
        ff="$mulishBold"
        fontSize="$font-size-xs"
        $gtMd={{ fontSize: '$font-size-md' }}
        alignSelf="center"
        fontWeight={700}
        maxWidth="70%"
        numberOfLines={3}
      >
        {title}
      </Text>
      {showButton && (
        <XStack
          gap={4}
          alignItems="center"
          $gtSm={{ gap: 8 }}
          $gtMd={{ paddingTop: '$size.spacing-nano' }}
          paddingRight="$size.spacing-xs"
          cursor="pointer"
          onPress={handlePress}
          onHoverIn={() => setButtonIsHovered(true)}
          onHoverOut={() => setButtonIsHovered(false)}
        >
          <Animated.View
            style={{
              opacity: setOpacity,
            }}
          >
            <Text
              color={setColor}
              paddingLeft="$size.spacing-xs"
              ff="$mulishBold"
              display={setDisplay()}
              fontSize="$font-size-xxxs"
              fontWeight={700}
              $gtSm={{ fontSize: '$font-size-xs' }}
            >
              {t('DefaultSectionTitle.seeAll')}
            </Text>
          </Animated.View>
          <HeroIcon
            icon={['fal', 'chevron-right']}
            size={iconSize}
            color={setColor}
            style={{
              paddingVertical: 2,
            }}
          />
        </XStack>
      )}
      {accessory && (
        <XStack
          marginLeft="auto"
          alignItems="center"
          paddingLeft="$size.spacing-xs"
        >
          {accessory}
        </XStack>
      )}
    </XStack>
  )
}
